const { OrderedMap } = require('immutable')

export const getIsLoading = state => !state.addressBook.isInitialized && state.addressBook.isLoading;

export const getAddressItems = state => {
  if (OrderedMap.isOrderedMap(state.addressBook.addressItems)) {
    return state.addressBook.addressItems.toIndexedSeq().toArray();
  }
  return [];
}

export const getErrorItems = state => {
  if (OrderedMap.isOrderedMap(state.addressBook.errorItems)) {
    return state.addressBook.errorItems.toIndexedSeq().toArray();
  }
  return [];
}

export const getWarningItems = state => {
  if (OrderedMap.isOrderedMap(state.addressBook.warningItems)) {
    return state.addressBook.warningItems.toIndexedSeq().toArray();
  }
  return [];
}

export const getNgList = state => {
  if (OrderedMap.isOrderedMap(state.addressBook.ngList)) {
    return state.addressBook.ngList.toIndexedSeq().toArray();
  }
  return [];
}


export const getCorporations = state => {
  if (OrderedMap.isOrderedMap(state.addressBook.corporations)) {
    return state.addressBook.corporations.toIndexedSeq().toArray();
  }
  return [];
}

export const getTags = state => state.addressBook.tags;

export const getAddressItemById = (state, id) => {
  if (state.addressBook.addressItems.hasOwnProperty(id)) {
    return state.addressBook.addressItems[id];
  } else {
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/redux/selectors/addressBookSelector.js